var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OverseasColumnSections'),_c('SiteFooter',{key:`footer-${_vm.pageKey}`})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }